module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.d2e691bc.ttf";